import React, { useState } from 'react'

import { GenderBookModal } from './GenderBookModal/GenderBookModal'
import { GenderBookButton } from './GenderBookButton/GenderBookButton'
import { PredictionResults } from '@models/Prediction/Prediction'
import { bookGenderMappingId } from '@models/Book'
import { Trans } from 'react-i18next'
import { ShareButton } from '../Share/ShareButton'
import './GenderBookGoToWebsiteHeader.scss'

export type GenderBookButtonProps = {
  gender?: string
  results?: PredictionResults
  withShare?: boolean
}
export const GenderBookGoToWebsiteHeader = ({ gender, results, withShare }: GenderBookButtonProps) => {
  const [showModal, setShowModal] = useState(false)

  const handleOnClickGoToWebsite = (skipAuth = false) => {
    if (!results) {
      return
    }

    const queryParams: Record<string, string> = {
      prediction: bookGenderMappingId[results?.prediction.selected].toString(),
    }

    if (skipAuth) {
      queryParams.skipAuth = 'true'
    } else {
      results?.prediction.data.forEach((data) => {
        const externalId = bookGenderMappingId[data.id]
        queryParams[`profile_${externalId}`] = data.value.toString()
      })
    }

    const queryString = new URLSearchParams(queryParams).toString()

    window.open(`https://app.leslibraires.ca/api/v1/datagotchi/reader-profile?${queryString}`, '_blank')
  }
  return (
    <div className={`GenderBookGoToWebsite ${!withShare ? 'GenderBookGoToWebsite-NoShare' : ''}`}>
      <div className="GenderBookGoToWebsite-Title">
        <Trans i18nKey={'Result:genderBookButtonShortTitle'} components={{ em: <em /> }} values={{ target: gender }} />
      </div>
      <div className="GenderBookGoToWebsite-Buttons">
        <GenderBookButton onClick={() => setShowModal(true)} />
        {withShare && <ShareButton />}
      </div>

      <GenderBookModal
        open={showModal}
        gender={gender}
        onClose={() => setShowModal(false)}
        onClickTransfer={() => handleOnClickGoToWebsite(false)}
        onClickOpen={() => handleOnClickGoToWebsite(true)}
      />
    </div>
  )
}
